const apiUrls = {
  // Base URL for the API
  baseUrl: 'https://tushark.in',
  // Example API endpoints
  imageURL: 'https://raw.githubusercontent.com/kaletushar222/static-data/main/portfolio-app/assets/img/',
  dataURL: 'https://raw.githubusercontent.com/kaletushar222/static-data/main/portfolio-app/dataFiles/',
  pdfURL: 'https://raw.githubusercontent.com/kaletushar222/static-data/main/portfolio-app/assets/pdf/',
  getPosts: '/posts',
  createUser: '/users/create',
  updatePost: '/posts/update',
  deletePost: '/posts/delete'
};
  
export default apiUrls;